/* Shared storefront readiness. Shopify's server-rendered template remains authoritative.
   This improves the storefront flow; checkout enforcement requires a Shopify validation app. */
(() => {
  'use strict';
  const node = document.getElementById('STCCartConfig');
  if (!node) return;
  const config = JSON.parse(node.textContent);
  const cartUrl = config.cartUrl.replace(/\/$/, '');
  const route = url => cartUrl + url.replace(/^\/cart/, '');
  const clean = value => {
    const text = String(value == null ? '' : value).trim();
    return !text || /^[-—–]$/.test(text) || /^n\/a$/i.test(text) ? '' : text;
  };
  const first = (properties, keys) => {
    // Preserve the established alias priority across the storefront and Liquid.
    for (const key of keys) if (String(properties[key] == null ? '' : properties[key]).trim()) return clean(properties[key]);
    return '';
  };
  const hasComplete = item => {
    const p = item.properties || {};
    if(p._stc_roster){const size=Number(p._stc_roster_size),fields=Object.keys(p).filter(k=>/^Personalization Text \d{3}$/.test(k));return p._stc_roster==='1'&&['7387012104261','8312513527877','8312513757253'].includes(String(item.product_id))&&String(p._stc_roster_variant)===String(item.variant_id)&&item.quantity===1&&Number.isSafeInteger(size)&&size>=2&&size<=100&&fields.length===size&&Array.from({length:size},(_,i)=>String(p['Personalization Text '+String(i+1).padStart(3,'0')]||'').trim()).every(t=>t&&t.length<=200);}
    return !!first(p, ['Personalization • Text','Text','Personalization text','Engraving Text','Personalization Text','What do you want it to say:','What do you want it to say']) ||
      !!first(p, ['Personalization • Artwork Link','Personalization • File','File','Design File','Design file','Upload','Upload / replace design file (optional):','Upload / replace design file (optional)']);
  };
  const requirements = async (cart, signal) => {
    if (!(cart.items || []).length) return new Map();
    const url = new URL(config.cartUrl, window.location.origin);
    url.searchParams.set('section_id', 'vq-personalization-requirements');
    // Use the current storefront session; forcing a theme ID starts preview mode.
    const response = await fetch(url, { credentials: 'same-origin', signal });
    if (!response.ok) throw new Error('Personalization requirements could not be loaded.');
    const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
    const data = doc.querySelector('[data-vq-template-requirements]');
    if (!data) throw new Error('Personalization requirements are unavailable.');
    const result = new Map(Object.entries(JSON.parse(data.textContent)));
    if (cart.items.some(item => !result.has(String(item.product_id)))) throw new Error('Personalization requirements changed. Please try again.');
    return result;
  };
  const ready = (cart, templates) => (cart.items || []).length > 0 && cart.items.every(item => templates.get(String(item.product_id)) !== 'customized' || hasComplete(item));
  const readCart = async signal => {
    const response = await fetch(route('/cart.js'), { credentials: 'same-origin', headers: { Accept: 'application/json' }, signal });
    if (!response.ok) throw new Error('Your Shopping List could not be verified.');
    const cart = await response.json();
    const templates = await requirements(cart, signal);
    return { cart, templates, ready: ready(cart, templates) };
  };
  const assertReady = async () => {
    const state = await readCart();
    if (!state.ready) throw new Error('Your Shopping List changed. Finish personalization before checkout.');
    return state.cart;
  };
  window.STCCartReadiness = Object.freeze({ route, clean, hasComplete, requirements, ready, readCart, assertReady });
})();

